(function(){
    angular
        .module('app')
        .directive('ngQuotes', quotes);

        quotes.$inject = ['$timeout'];
        function quotes($timeout){
            return {
            restrict:'A',
            replace: true,
            transclude: true,
            scope: { control : "=" },
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    //console.log("E");
                    var value = $attrs.value;
                    var $element = $(element);
                    var name = $element.attr("name");
                    $element.on('keyup', function() {
                        var valor = $element.val();
                        $element.val(valor.replace(/"/g,"'"));
                    });
                });
            }
          }
      }
})();